import { IS_MY_TEAM, IS_PUBLIC_ALBUM } from 'reactApp/appHelpers/configHelpers';
import { getStorageItemById } from 'reactApp/modules/storage/storage.selectors';
import { type CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { WorkspaceSuperAppService } from 'reactApp/services';
import { store } from 'reactApp/store';
import { getPublicUrl } from 'reactApp/utils/urlHelper';

import { MAIL_HOST } from './attaches.constants';

export const getSendViaMailruLink = (idxs: (string | CloudItem)[], storage: EStorageType): string => {
    if (!Array.isArray(idxs)) {
        idxs = [idxs];
    }

    const state = store.getState();
    const eitherAlbumOrPublic = storage === EStorageType.public || storage === EStorageType.albums || storage === EStorageType.vigbo;

    const ids = idxs.reduce(
        (collection: { attaches: string[]; links: string[] }, idOrItem: string | CloudItem) => {
            const item = typeof idOrItem === 'string' ? getStorageItemById(state, storage, idOrItem) : idOrItem;

            if (item) {
                try {
                    if (eitherAlbumOrPublic) {
                        if ('home' in item && item.home) {
                            collection.attaches.push(encodeURIComponent(item.home));
                        } else {
                            collection.links.push(getPublicUrl(item, IS_PUBLIC_ALBUM) || item.id || '');
                        }
                    } else {
                        collection.attaches.push(encodeURIComponent(item.id || ''));
                    }
                } catch (error) {}
            }

            return collection;
        },
        { attaches: [], links: [] }
    );

    if (ids.attaches.length || ids.links.length) {
        const attachValues = (ids.attaches.length && `cloud_files_ids=${JSON.stringify(ids.attaches)}`) || '';
        const linkValues = (ids.links.length && `body=${ids.links.join(encodeURIComponent('\n'))}`) || '';
        const uriComponent = [attachValues, linkValues].filter(Boolean).join('&');
        const isWorkspaceSuperAppMode = WorkspaceSuperAppService.isEnabled;

        if (isWorkspaceSuperAppMode) {
            return `${WorkspaceSuperAppService.superAppOrigin.origin}/mail/compose/?${uriComponent}`;
        }

        return IS_MY_TEAM ? `vkteams://miniapp/mail/?path=compose&${uriComponent}` : `https://${MAIL_HOST}/compose/?${uriComponent}`;
    }

    return '';
};
